import React from 'react';

 const LoadingSpinner = () => {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-white/50 z-50">
      <div className="dot-loader">
        <div></div><div></div><div></div>
      </div>
    </div>
  );
};

export default LoadingSpinner;